app.controller("AreaNaviController",
	["$scope", "AreaNaviService", function($scope, AreaNaviService) {
		$scope.area = AreaNaviService;
	}]
);